import React from 'react';
import { TableRow, TableCell, Box, Typography, Chip } from '@mui/material';
import { ChevronRight as ChevronRightIcon, ExpandMore as ExpandMoreIcon, Folder as FolderIcon } from '@mui/icons-material';
import { colors, fonts, spacing } from '../../constants';
import { formatQueryProjectNameForDisplay } from '../../utils/projectsUtils';

/**
 * ProjectHeaderRow Component
 * Project header row in table
 */
const ProjectHeaderRow = ({
  projectName,
  projectsCatalog = [],
  queryCount,
  isExpanded,
  onToggle,
  tableBodyCellStyles,
}) => {
  const displayName = formatQueryProjectNameForDisplay(projectName, projectsCatalog);
  return (
    <TableRow
      sx={{
        backgroundColor: colors.backgroundWhite,
        background: colors.backgroundWhite,
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          backgroundColor: colors.backgroundLight,
          background: colors.backgroundLight,
        },
      }}
      onClick={onToggle}
    >
      <TableCell
        colSpan={6}
        sx={{
          ...tableBodyCellStyles,
          py: spacing.sm,
          px: spacing.md,
          borderBottom: `1px solid ${colors.borderDefault}`,
          borderRight: `1px solid ${colors.borderDefault}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: spacing.xs,
            cursor: 'pointer',
            padding: `${spacing.xs} ${spacing.sm}`,
            transition: 'all 0.2s ease',
          }}
        >
          {isExpanded ? (
            <ExpandMoreIcon 
              sx={{ 
                color: colors.primaryDark, 
                fontSize: '16px',
                opacity: 1,
                display: 'inline-flex',
                flexShrink: 0,
              }} 
            />
          ) : (
            <ChevronRightIcon 
              sx={{ 
                color: colors.primaryDark, 
                fontSize: '16px',
                opacity: 1,
                display: 'inline-flex',
                flexShrink: 0,
                transform: 'rotate(0deg)',
                transition: 'transform 0.2s ease',
              }} 
            />
          )}
          <FolderIcon 
            sx={{ 
              color: colors.primaryDark, 
              fontSize: '16px',
              opacity: 1,
              display: 'inline-flex',
              flexShrink: 0,
            }} 
          />
          <Typography
            component="span"
            sx={{
              fontWeight: fonts.weightSemiBold,
              fontSize: '0.8125rem',
              color: colors.primaryDark,
              letterSpacing: '0.01em',
            }}
          >
            {displayName}
          </Typography>
          <Chip
            label={queryCount}
            size="small"
            sx={{
              backgroundColor: colors.primaryTint,
              color: colors.primaryDark,
              fontWeight: fonts.weightSemiBold,
              fontSize: '0.7rem',
              height: '20px',
              border: `1px solid ${colors.primaryTintHover}`,
            }}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default ProjectHeaderRow;
